import React, { useState } from "react";
import { locationData } from "../../../../constansts/LocalData";
import BodyHeader from "../../../../components/common/CommonBodyHeader/index";
import CustomDropdown from "../../../../components/common/CustomDropdown/CustomDropdown";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import CustomTextArea from "../../../../components/common/CustomTextArea/CustomTextArea";
import CustomFileUpload from "../../../../components/common/CustomFileUpload/CustomFileUpload";
import CustomDatePicker from "../../../../components/common/CustomDatePicker/CustomDatePicker";
import { FormikProvider, useFormik } from "formik";
import { AddVendorValidationSchema } from "../../../../constansts/validationSchema";

const AdhocVendorAdd = () => {
   const [isDisabled, setIsdisabled] = useState(true);
   const [islaneNameSelected, setIslaneNameSelected] = useState({});

   const formik = useFormik({
      initialValues: {
         vendor: {
            name: "",
            accountNumber: "",
            bankName: "",
            ifscCode: "",
            accountHolderName: "",
            bankDocument: "",
            gstNumber: "",
            gstDocument: "",
            location: "",
            address: "",
         },
         contactPersons: [
            {
               name: "",
               mobile: "",
               email: "",
            },
         ],
         agreement: {
            startDate: "",
            endDate: "",
            document: "",
         },
         lanes: [
            {
               name: "",
               expressRate: "",
               superExpressRate: "",
               detentionRate: "",
               loadingRate: "",
               unloadingRate: "",
               loadingCharge: "",
               unloadingCharge: "",
               miscellaneousCharges: "",
               miscellaneousRemarks: "",
            },
         ],
      },

      validationSchema: AddVendorValidationSchema,
      onSubmit: () => {
      },
   });
   const { errors, getFieldProps, touched, handleSubmit, setFieldValue, resetForm } =
      formik;
   const { vendor, contactPersons, agreement, lanes } = formik?.values;

   // Add contact button handler
   const handleAddContact = () => {
      setFieldValue("contactPersons", [
         ...contactPersons,
         {
            name: "",
            mobile: "",
            email: "",
         },
      ]);
   };

   // Delete contact button handler
   const handleRemoveContact = (index) => {
      const updatedContactPersons = [...contactPersons];
      updatedContactPersons.splice(index, 1);
      setFieldValue("contactPersons", updatedContactPersons);
   };

   // Lane name select handler
   const handleLaneNameSelect = (index, values) => {
      setIsdisabled(false);
      setFieldValue(`lanes[${index}].name`, values[0]?.value);
   };

   // Add lane button handler
   const handleAddLane = () => {
      setFieldValue("lanes", [
         ...lanes,
         {
            name: "",
            expressRate: "",
            superExpressRate: "",
            detentionRate: "",
            loadingRate: "",
            unloadingRate: "",
            loadingCharge: "",
            unloadingCharge: "",
            miscellaneousCharges: "",
            miscellaneousRemarks: "",
         },
      ]);
   };

   const handleRemoveLane = (index) => {
      const updatedLane = [...lanes];
      updatedLane.splice(index, 1);
      setFieldValue("lanes", updatedLane);
   };

   const destinationData = [
      {
         label: "Lane 1",
         value: "Lane 1",
      },
      {
         label: "Lane 2",
         value: "Lane 2",
      },
      {
         label: "Lane 3",
         value: "Lane 3",
      },
      {
         label: "Lane 4",
         value: "Lane 4",
      },
   ];

   return (
      <div>
         <BodyHeader title="Manager Add Vendor" />
         <FormikProvider value={formik}>
            <div className="p-3 shadow-lg">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="card card-primary">
                        <div className="card-header">
                           <h3 className="card-title">Vendor Details</h3>
                        </div>
                        <div className="card-body">
                           <div className="row">
                              <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                                 <CustomInput
                                    require
                                    label="Vendor Name"
                                    id="vendorName"
                                    placeholder="Enter Vendor Name"
                                    {...getFieldProps("vendor.name")}
                                    errors={touched?.vendor?.name && errors?.vendor?.name}
                                    message={errors?.vendor?.name}
                                 />
                              </div>
                              <div className="col-lg-4">
                                 <CustomInput
                                    require
                                    label="Account Number"
                                    id="AccountNumber"
                                    placeholder="Enter Account Number"
                                    {...getFieldProps("vendor.accountNumber")}
                                    errors={
                                       touched?.vendor?.accountNumber &&
                                       errors?.vendor?.accountNumber
                                    }
                                    message={errors?.vendor?.accountNumber}
                                 />
                              </div>
                              <div className="col-lg-4">
                                 <CustomInput
                                    require
                                    label="Bank name"
                                    id="bankName"
                                    placeholder="Enter Bank Name"
                                    {...getFieldProps("vendor.bankName")}
                                    errors={
                                       touched?.vendor?.bankName &&
                                       errors?.vendor?.bankName
                                    }
                                    message={errors?.vendor?.bankName}
                                 />
                              </div>
                              <div className="col-lg-4">
                                 <CustomInput
                                    require
                                    label="IFSC Code"
                                    id="ifscCode"
                                    placeholder="Enter IFSC Code"
                                    {...getFieldProps("vendor.ifscCode")}
                                    errors={
                                       touched?.vendor?.ifscCode &&
                                       errors?.vendor?.ifscCode
                                    }
                                    message={errors?.vendor?.ifscCode}
                                 />
                              </div>

                              <div className="col-lg-4">
                                 <CustomInput
                                    require
                                    label="Account Holder Name"
                                    id="accountHolderName"
                                    placeholder="Enter Account Holder name"
                                    {...getFieldProps("vendor.accountHolderName")}
                                    errors={
                                       touched?.vendor?.accountHolderName &&
                                       errors?.vendor?.accountHolderName
                                    }
                                    message={errors?.vendor?.accountHolderName}
                                 />
                              </div>
                              <div className="col-lg-4">
                                 <CustomFileUpload
                                    label="Bank Document"
                                    id="bankDetails"
                                    {...getFieldProps("vendor.bankDocument")}
                                    onChange={(e) => {
                                       setFieldValue(
                                          "vendor.bankDocument",
                                          e.target.files[0]
                                       );
                                    }}
                                    errors={
                                       touched?.vendor?.bankDocument &&
                                       errors?.vendor?.bankDocument
                                    }
                                    message={errors?.vendor?.bankDocument}
                                 />
                              </div>
                              <div className="col-lg-4">
                                 <CustomInput
                                    require
                                    label="GST Number"
                                    id="gstNumber"
                                    placeholder="Enter GST Number"
                                    {...getFieldProps("vendor.gstNumber")}
                                    errors={
                                       touched?.vendor?.gstNumber &&
                                       errors?.vendor?.gstNumber
                                    }
                                    message={errors?.vendor?.gstNumber}
                                 />
                              </div>
                              <div className="col-lg-4">
                                 <CustomFileUpload
                                    label="GST Document"
                                    id="gst"
                                    {...getFieldProps("vendor.gstDocument")}
                                    onChange={(e) => {
                                       setFieldValue(
                                          "vendor.gstDocument",
                                          e.target.files[0]
                                       );
                                    }}
                                    errors={
                                       touched.vendor?.gstDocument &&
                                       errors.vendor?.gstDocument
                                    }
                                    message={errors.vendor?.gstDocument}
                                 />
                              </div>

                              <div className="col-lg-4">
                                 <label htmlFor="address">location</label>
                                 <CustomDropdown
                                    optionData={locationData}
                                    onChange={(values) => {
                                       setFieldValue("vendor.location", values[0].value);
                                    }}
                                    errors={
                                       touched?.vendor?.location &&
                                       errors?.vendor?.location
                                    }
                                    message={errors?.vendor?.location}
                                 />
                              </div>
                              <div className="col-lg-12">
                                 <CustomTextArea
                                    label="Address"
                                    id="VendorLocation"
                                    {...getFieldProps("vendor.address")}
                                    errors={
                                       touched?.vendor?.address && errors?.vendor?.address
                                    }
                                    message={errors?.vendor?.address}
                                 />
                              </div>
                              <div className="col-12">
                                 {contactPersons?.map((contactPerson, index) => {
                                    return (
                                       <div
                                          key={index}
                                          className={
                                             index < contactPersons.length - 1 &&
                                             contactPersons.length > 1
                                                ? "row border-bottom mb-4 pb-3"
                                                : "row"
                                          }
                                       >
                                          <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                                             <CustomInput
                                                require
                                                label="Contact Person Name"
                                                id="#vendorMobile"
                                                placeholder="Enter Contact Person Name."
                                                {...getFieldProps(
                                                   `contactPersons[${index}].name`
                                                )}
                                                errors={
                                                   touched.contactPersons?.[index]
                                                      ?.name &&
                                                   errors.contactPersons?.[index]?.name
                                                }
                                                message={
                                                   errors.contactPersons?.[index]?.name
                                                }
                                             />
                                          </div>
                                          <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                                             <CustomInput
                                                require
                                                label="Mobile No"
                                                id="vendorMobile"
                                                placeholder="Enter Contact Person Mobile No."
                                                {...getFieldProps(
                                                   `contactPersons[${index}].mobile`
                                                )}
                                                errors={
                                                   touched.contactPersons?.[index]
                                                      ?.mobile &&
                                                   errors.contactPersons?.[index]?.mobile
                                                }
                                                message={
                                                   errors.contactPersons?.[index]?.mobile
                                                }
                                             />
                                          </div>
                                          <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                                             <CustomInput
                                                require
                                                label="Email Id"
                                                id="#vendorEmail"
                                                placeholder="Enter Contact Person Email"
                                                {...getFieldProps(
                                                   `contactPersons[${index}].email`
                                                )}
                                                errors={
                                                   touched.contactPersons?.[index]
                                                      ?.email &&
                                                   errors.contactPersons?.[index]?.email
                                                }
                                                message={
                                                   errors.contactPersons?.[index]?.email
                                                }
                                             />
                                          </div>

                                          {index > 0 && (
                                             <div className="col-12">
                                                <button
                                                   type="button"
                                                   className="btn btn-danger float-right ml-3 mb-3"
                                                   onClick={() =>
                                                      handleRemoveContact(index)
                                                   }
                                                >
                                                   <i className="fas fa-trash"></i> Delete
                                                   item
                                                </button>
                                             </div>
                                          )}
                                       </div>
                                    );
                                 })}
                                 <button
                                    type="button"
                                    className="btn btn-primary float-right"
                                    onClick={handleAddContact}
                                 >
                                    <i className="fas fa-plus"></i> Add item
                                 </button>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div className="row">
                  <div className="col-lg-12">
                     <div className="card card-primary">
                        <div className="card-header">
                           <h3 className="card-title">Agreement Details</h3>
                        </div>
                        <div className="card-body row">
                           <div className="col-lg-4">
                              <CustomDatePicker
                                 label="Agreement Start Date"
                                 placeholder="Enter Agreement Start Date"
                                 {...getFieldProps("agreement.startDate")}
                                 errors={
                                    touched.agreement?.startDate &&
                                    errors.agreement?.startDate
                                 }
                                 message={errors.agreement?.startDate}
                              />
                           </div>
                           <div className="col-lg-4">
                              <CustomDatePicker
                                 label="Agreement End Date"
                                 placeholder="Enter Agreement End Date"
                                 {...getFieldProps("agreement.endDate")}
                                 errors={
                                    touched.agreement?.startDate &&
                                    errors.agreement?.endDate
                                 }
                                 message={errors.agreement?.endDate}
                              />
                           </div>
                           <div className="col-lg-4">
                              <CustomFileUpload
                                 label="Agreement Document"
                                 {...getFieldProps("agreement.document")}
                                 errors={
                                    touched.agreement?.document &&
                                    errors.agreement?.document
                                 }
                                 message={errors.agreement?.document}
                              />
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div className="row">
                  <div className="col-lg-12">
                     <div className="card card-primary">
                        <div className="card-header">
                           <h3 className="card-title">Lane Details</h3>
                        </div>
                        <div className="card-body row">
                           {lanes.map((lane, index) => (
                              <div>
                                 {lanes.length > 1 && index > 0 && <hr />}
                                 <div className="row mt-3">
                                    <div className="col-lg-4">
                                       <CustomDropdown
                                          label="Lane Name"
                                          optionData={destinationData}
                                          onChange={(values) =>
                                             handleLaneNameSelect(index, values)
                                          }
                                          errors={
                                             touched.lanes?.[index]?.name &&
                                             errors.lanes?.[index]?.name
                                          }
                                          message={errors.lanes?.[index]?.name}
                                       />
                                    </div>
                                 </div>

                                 <div className="row mt-3">
                                    <div className="col-lg-4">
                                       <CustomInput
                                          inputType="number"
                                          require
                                          label="Express mode rate additional"
                                          id="expressModeRateAdditional"
                                          placeholder="Enter Amount"
                                          {...getFieldProps(
                                             `lanes[${index}].expressRate`
                                          )}
                                          errors={
                                             touched.lanes?.[index]?.expressRate &&
                                             errors.lanes?.[index]?.expressRate
                                          }
                                          message={errors.lanes?.[index]?.expressRate}
                                       />
                                    </div>
                                    <div className="col-lg-4">
                                       <CustomInput
                                          inputType="number"
                                          require
                                          label="Super express mode rate additional"
                                          id="superExpressModeRateAdditional"
                                          placeholder="Enter amount"
                                          {...getFieldProps(
                                             `lanes[${index}].superExpressRate`
                                          )}
                                          errors={
                                             touched.lanes?.[index]?.superExpressRate &&
                                             errors.lanes?.[index]?.superExpressRate
                                          }
                                          message={
                                             errors?.lanes?.[index]?.superExpressRate
                                          }
                                       />
                                    </div>
                                    <div className="col-lg-4">
                                       <CustomInput
                                          inputType="number"
                                          require
                                          label="Detention rate additional"
                                          id="detentionRateAdditional"
                                          placeholder="Enter amount"
                                          {...getFieldProps(
                                             `lanes[${index}].detentionRate`
                                          )}
                                          errors={
                                             touched.lanes?.[index]?.detentionRate &&
                                             errors.lanes?.[index]?.detentionRate
                                          }
                                          message={errors.lanes?.[index]?.detentionRate}
                                       />
                                    </div>
                                    <div className="col-lg-4">
                                       <CustomInput
                                          inputType="number"
                                          require
                                          label="Multiple loading location rate additional"
                                          id="multipleLoadingLocationRateAdditional"
                                          placeholder="Enter amount"
                                          {...getFieldProps(
                                             `lanes[${index}].loadingRate`
                                          )}
                                          errors={
                                             touched.lanes?.[index]?.loadingRate &&
                                             errors.lanes?.[index]?.loadingRate
                                          }
                                          message={errors.lanes?.[index]?.loadingRate}
                                       />
                                    </div>

                                    <div className="col-lg-4">
                                       <CustomInput
                                          inputType="number"
                                          require
                                          label="Multiple unloading location rate additional"
                                          id="multipleUnloadingLocationRateAdditional"
                                          placeholder="Enter amount"
                                          {...getFieldProps(
                                             `lanes[${index}].unloadingRate`
                                          )}
                                          errors={
                                             touched.lanes?.[index]?.unloadingRate &&
                                             errors.lanes?.[index]?.unloadingRate
                                          }
                                          message={errors.lanes?.[index]?.unloadingRate}
                                       />
                                    </div>
                                    <div className="col-lg-4">
                                       <CustomInput
                                          inputType="number"
                                          require
                                          label="Loading charges"
                                          id="loadingCharges"
                                          placeholder="Enter amount"
                                          {...getFieldProps(
                                             `lanes[${index}].loadingCharge`
                                          )}
                                          errors={
                                             touched.lanes?.[index]?.loadingCharge &&
                                             errors.lanes?.[index]?.loadingCharge
                                          }
                                          message={errors.lanes?.[index]?.loadingCharge}
                                       />
                                    </div>
                                    <div className="col-lg-4">
                                       <CustomInput
                                          inputType="number"
                                          require
                                          label="Unloading charge"
                                          id="unloadingCharge"
                                          placeholder="Enter amount"
                                          {...getFieldProps(
                                             `lanes[${index}].unloadingCharge`
                                          )}
                                          errors={
                                             touched.lanes?.[index]?.unloadingCharge &&
                                             errors.lanes?.[index]?.unloadingCharge
                                          }
                                          message={
                                             errors?.lanes?.[index]?.unloadingCharge
                                          }
                                       />
                                    </div>
                                    <div className="col-lg-4">
                                       <CustomInput
                                          inputType="number"
                                          require
                                          label="miscellaneous charges"
                                          id="miscellaneousCharges"
                                          placeholder="Enter amount"
                                          {...getFieldProps(
                                             `lanes[${index}].miscellaneousCharges`
                                          )}
                                          errors={
                                             touched.lanes?.[index]
                                                ?.miscellaneousCharges &&
                                             errors.lanes?.[index]?.miscellaneousCharges
                                          }
                                          message={
                                             errors.lanes?.[index]?.miscellaneousCharges
                                          }
                                       />
                                    </div>
                                    <div className="col-lg-4">
                                       <CustomInput
                                          require
                                          label="miscellaneous Remarks"
                                          id="miscellaneousRemarks"
                                          placeholder="Enter remarks"
                                          {...getFieldProps(
                                             `lanes[${index}].miscellaneousRemarks`
                                          )}
                                          errors={
                                             touched.lanes?.[index]
                                                ?.miscellaneousRemarks &&
                                             errors.lanes?.[index]?.miscellaneousRemarks
                                          }
                                          message={
                                             errors.lanes?.[index]?.miscellaneousRemarks
                                          }
                                       />
                                    </div>
                                 </div>
                                 {index > 0 && (
                                    <div className="col-12">
                                       <button
                                          type="button"
                                          className="btn btn-danger float-right ml-3 mb-3"
                                          onClick={() => handleRemoveLane(index)}
                                       >
                                          <i className="fas fa-trash"></i> Delete item
                                       </button>
                                    </div>
                                 )}
                              </div>
                           ))}
                           <div className="col-12">
                              <button
                                 type="button"
                                 className="btn btn-primary float-right"
                                 onClick={handleAddLane}
                              >
                                 <i className="fas fa-plus"></i> Add item
                              </button>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div className="mt-3 text-center">
                  <button
                     className="btn btn-primary px-4 py-3"
                     type="submit"
                     onClick={handleSubmit}
                  >
                     <h6 className="mb-0 text-uppercase">Submit</h6>
                  </button>
                  <button
                     className="btn btn-danger ml-3 px-4 py-3"
                     type="submit"
                     onClick={resetForm}
                  >
                     <h6 className="mb-0 text-uppercase">reset</h6>
                  </button>
               </div>
            </div>
         </FormikProvider>
      </div>
   );
};

export default AdhocVendorAdd;
